var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 52.8027H10.5M19.5 36.3027H6M27 19.8027H12M51 9.30273L31.2107 37.0078C30.3348 38.234 29.8969 38.8471 29.9158 39.3583C29.9323 39.8034 30.1457 40.2181 30.4983 40.4902C30.9032 40.8027 31.6567 40.8027 33.1637 40.8027H48L45 63.3027L64.7893 35.5977C65.6652 34.3715 66.1031 33.7583 66.0842 33.2472C66.0677 32.8021 65.8543 32.3874 65.5017 32.1153C65.0968 31.8027 64.3433 31.8027 62.8363 31.8027H48L51 9.30273Z",
    stroke: "#72C420",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService3);
export default __webpack_public_path__ + "static/media/service3.0fefc0402d0934a0cb74a719858688b3.svg";
export { ForwardRef as ReactComponent };